module.exports = __webpack_public_path__ + "img/logo.887040a9.png";